import { Text } from './Text'
import { Props } from './typings'

export function H2(props: Props) {
  const { children = '', as, className = '', style, size, weight, ...p } = props

  return (
    <Text size="$h2" weight="$semiBold" as={'h2'} style={style} className={className} {...p}>
      {children}
    </Text>
  )
}
